import classnamesBind from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import shortId from '@concur/nui-widgets/lib/utils/shortId';

const ConcurLogo = (props) => {
    const {
        classNameMap,
        fill1ClassName,
        fill2ClassName,
        ...otherProps
    } = props;

    const classnames = classnamesBind.bind(classNameMap);

    const idSuffix = shortId.generate();

    return (
        <svg
            id={`Concur_logo_${idSuffix}`}
            data-test="Concur_logo"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="129"
            height="32"
            viewBox="0 0 129 32"
            preserveAspectRatio="xMinYMin meet"
            role="img"
            {...otherProps}
        >
            <title>Concur</title>
            <path
                className={classnames(fill1ClassName)}
                d="M30.873 0.245h-28.692c-0.964 0-1.752 0.794-1.752 1.758v28.018c0 0.964 0.787 1.734 1.752 1.734h28.692c0.964 0 1.74-0.77 1.74-1.734v-28.018c0-0.964-0.776-1.758-1.74-1.758zM20.911 24.787c-1.286 0.785-3.341 1.213-5.029 1.225-3.144 0.023-5.916-1.274-7.821-3.314-1.696-1.794-2.717-4.173-2.717-6.738 0-5.926 4.662-10.248 10.285-10.051 1.097 0 2.158 0.186 3.13 0.484 1.095 0.329 2.079 0.803 2.878 1.318 0.394 0.255 0.387 0.378 0.303 0.495-0.331 0.461-1.234 1.797-1.689 2.734 0 0-0.111 0.221-0.336 0.1-0.029-0.009-0.061-0.023-0.095-0.045-0.353-0.231-0.751-0.459-1.22-0.656-0.803-0.329-1.81-0.564-3.144-0.564-3.332 0-5.868 2.605-5.868 6.149 0 1.88 0.831 3.506 2.109 4.618 1.124 0.959 2.584 1.524 4.125 1.521 1.147-0.002 2.339-0.408 2.745-0.557 0.115-0.042 0.191 0.002 0.235 0.046 0.074 0.035 0.107 0.107 0.107 0.107 0.8 1.702 1.864 2.487 2.11 2.83 0.125 0.174-0.109 0.298-0.109 0.298zM24.823 22.415c-0.597 0-1.151-0.183-1.61-0.495-0.793-0.508-1.319-1.396-1.319-2.408 0-1.578 1.28-2.857 2.858-2.857 0.465 0 0.903 0.112 1.291 0.309 0.97 0.458 1.641 1.445 1.641 2.588 0 1.582-1.282 2.863-2.862 2.863zM38.333 15.937c0-4.365 3.301-7.343 7.555-7.343 3.13 0 4.937 1.703 5.938 3.471l-2.596 1.272c-0.598-1.149-1.873-2.062-3.343-2.062-2.576 0-4.447 1.978-4.447 4.662 0 2.679 1.871 4.66 4.447 4.66 1.47 0 2.745-0.894 3.343-2.066l2.596 1.257c-1.020 1.766-2.808 3.488-5.938 3.488-4.254 0-7.555-2.979-7.555-7.338M53.109 15.937c0-4.28 3.132-7.343 7.409-7.343 4.299 0 7.426 3.063 7.426 7.343 0 4.274-3.126 7.338-7.426 7.338-4.276 0-7.409-3.065-7.409-7.338M64.837 15.937c0-2.659-1.702-4.662-4.32-4.662s-4.3 2.002-4.3 4.662c0 2.635 1.683 4.66 4.3 4.66s4.32-2.024 4.32-4.66M80.281 23.023l-6.77-9.257v9.257h-3.020v-14.198h3.108l6.576 8.918v-8.918h3.023v14.198zM85.739 15.937c0-4.365 3.299-7.343 7.551-7.343 3.133 0 4.94 1.703 5.941 3.471l-2.598 1.272c-0.596-1.149-1.873-2.062-3.343-2.062-2.571 0-4.445 1.978-4.445 4.662 0 2.679 1.873 4.66 4.445 4.66 1.47 0 2.747-0.894 3.343-2.066l2.598 1.257c-1.021 1.766-2.808 3.488-5.941 3.488-4.252 0-7.551-2.979-7.551-7.338M101.22 17.358v-8.533h3.069v8.43c0 1.978 1.143 3.34 3.338 3.34 2.193 0 3.321-1.363 3.321-3.34v-8.43h3.088v8.515c0 3.53-2.090 5.935-6.409 5.935s-6.408-2.423-6.408-5.917M125.036 23.023l-2.788-5.044h-2.213v5.044h-3.024v-14.197h6.641c2.957 0 4.766 1.935 4.766 4.577 0 2.51-1.574 3.854-3.106 4.213l3.192 5.408h-3.468zM125.332 13.402c0-1.194-0.911-1.917-2.127-1.917h-3.169v3.833h3.169c1.216 0 2.127-0.727 2.127-1.917"
            />
        </svg>
    );
};

ConcurLogo.displayName = 'ConcurLogo';

ConcurLogo.propTypes = {
    fill1ClassName: PropTypes.string,
    fill2ClassName: PropTypes.string,
};

export default ConcurLogo;
